import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http";
import NoData_Coral from "./NoData_Coral";
import ChartLoader_Coral from "./ChartLoader_Coral";
import { Chart } from "react-google-charts";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";

const pie_chart_name = {
  1: "Power",
  2: "Eco",
  3: "Regen",
};

function SinglePie_Coral({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [["Element", "Count"]];
      res_result_final.push(["Power", temp_result[0].powerMode.value]);
      res_result_final.push(["Eco", temp_result[0].ecoMode.value]);
      res_result_final.push(["Regen", temp_result[0].RegenMode.value]);
      setChartData((prestate) => res_result_final);
    }
    if (res_result[0].doc_count === 0) {
      setChartData((prestate) => []);
    }
  };

  const options = {
    colors: ["#358696", "#ffa650", "#72d817"],

    sliceVisibilityThreshold: 0,
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph">
        <div className="titlebg titlebd_drive">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : chartdata.length == 0 ? (
            <NoData_Coral />
          ) : (
            <Chart
              chartType="PieChart"
              width="100%"
              height="180px"
              data={chartdata}
              options={options}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default SinglePie_Coral;
